import { render } from "./ResetPasswordError.vue?vue&type=template&id=740e4d65&scoped=true"
import script from "./ResetPasswordError.vue?vue&type=script&lang=js"
export * from "./ResetPasswordError.vue?vue&type=script&lang=js"

import "./reset-password.scss?vue&type=style&index=0&id=740e4d65&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-740e4d65"]])

export default __exports__